import AnimationController from './animation';

/* 	CursorController

	1) Provides unified cursor coordinates

*/

class CursorController {

	controllers = {
		animation: null,
		resize: null
	};

	config = {
		lerp: {
			ratio: 0.15,
			roundOff: 0.05
		}
	};

	coords = {
		cursor: {
			pageX: 0,
			pageY: 0,
			lerped: {
				pageX: 0,
				pageY: 0
			}
		}
	};

	initialize() {
		this.addEventListeners();
	}

	// listeners

	addEventListeners() {
		document.body.addEventListener('mousemove', this.#onMouseMove);
		document.body.addEventListener('touchmove', this.#onTouchMove);

		this.controllers.animation = AnimationController.set({
			update: this.#onAnimationUpdate,
			render: this.#onAnimationRender
		});
	}

	removeEventListeners() {
		document.body.removeEventListener('mousemove', this.#onMouseMove);
		document.body.removeEventListener('touchmove', this.#onTouchMove);
	}

	// listener methods

	#onMouseMove = (e) => {
		this.coords.cursor.pageX = e.pageX;
		this.coords.cursor.pageY = e.pageY;
	};

	#onTouchMove = (e) => {
		this.coords.cursor.pageX = e.touches[0].pageX;
		this.coords.cursor.pageY = e.touches[0].pageY;
	};

	// controller methods

	checkRounding(coordinate) {
		let roundedCoordinate = coordinate;
		if (Math.abs(roundedCoordinate) < this.config.lerp.roundOff) {
			roundedCoordinate = 0;
		}
		return roundedCoordinate;
	}

	#onAnimationUpdate = () => {
		const pageXLast = this.coords.cursor.lerped.pageX;
		const pageYLast = this.coords.cursor.lerped.pageY;

		this.coords.cursor.lerped.pageX = this.checkRounding(pageXLast + (this.coords.cursor.pageX - pageXLast) * this.config.lerp.ratio);
		this.coords.cursor.lerped.pageY = this.checkRounding(pageYLast + (this.coords.cursor.pageY - pageYLast) * this.config.lerp.ratio);
	};

	#onAnimationRender = () => { };

	// show / hide cursor

	showCursor() {
		document.body.style.cursor = 'default';
	}

	hideCursor() {
		document.body.style.cursor = 'none';
	}

	//

	scrollChunk(chunk) {
		if (chunk) {
			this.coords.cursor.pageY += chunk;
			this.coords.cursor.lerped.pageY = this.coords.cursor.pageY;
		}
	}

	// getters

	get lerpX() {
		return this.coords.cursor.lerped.pageX;
	}

	get lerpY() {
		return this.coords.cursor.lerped.pageY;
	}

	get cursorX() {
		return this.coords.cursor.pageX;
	}

	get cursorY() {
		return this.coords.cursor.pageY;
	}

	// destroy

	destroy() {
		this.removeEventListeners();
	}

}

export default new CursorController();
